<template>
  <div>
    <PageHeader
        v-if="!assignment_loading"
        :title="item.name || ''"
        class="assignment-details-page-header"
        icon="uil-book-open"
    />

    <!-- MODALS -->
    <modal :adaptive="false" name="survey_list_modal">
      <EvaluationQuestionList :modal_name="'survey_list_modal'" :modal_title="survey_name"
                              :survey="item.evaluation_survey" style="height:100% !important"
                              @onSubmit="saveEvaluationSurvey"/>
    </modal>

    <modal :adaptive="false" name="rate_education_modal" style="width:500px;height: auto;">
      <Rating :modal_name="'rate_education_modal'" :survey="item.survey" @onSubmit="saveRating"/>
    </modal>

    <!-- COUNTDOWN MODAL -->
    <CountdownModal ref="countdownModal" @continue="onInactivityContinue" @timeout="onInactivityTimeout"/>

    <ContentPlaybackDiagnostics ref="contentPlaybackDiagnostics"
                                :content-title="selected_content && selected_content.title"/>

    <InstructorProfileModal
      v-if="selectedInstructor"
      :instructor="selectedInstructor"
      @close="closeInstructorProfile"
    />

    <!-- CONTENT MODAL -->
    <div id="content_modal" bg-close="false" class="p-0 content-modal-wrapper" esc-close="false"
         style="z-index: 9999999; background:#dddddd;" uk-modal>
      <div v-if="selected_content != null" class="uk-modal-dialog bg-transparent content-modal-dialog"
           style="width: 100%">
        <div v-if="!isScormContent" class="content-modal-header">
          <button class="content-close-btn uk-modal-close-default" type="button" uk-close></button>
          <h2 class="content-modal-title">{{ selected_content.title }}</h2>
          <button class="content-diagnostics-link"
                  type="button"
                  @click.stop.prevent="openPlaybackDiagnostics"
          >
            <span class="content-diagnostics-link__full">{{ $t('general.cant_watch_training') }}</span>
            <span class="content-diagnostics-link__short">{{ $t('general.having_trouble') }}</span>
          </button>
        </div>
        <template v-else>
          <button class="content-close-btn uk-modal-close-default" type="button" uk-close></button>
          <button :title="$t('general.cant_watch_training')"
                  class="scorm-help-compact"
                  type="button"
                  @click.stop.prevent="openPlaybackDiagnostics"
          >
            <i class="uil-question-circle"></i>
          </button>
        </template>
        <div :class="{ 'no-footer': !showContentFooter }" class="uk-modal-body py-0 content-modal-body"
             style="overflow: auto;">
          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.visualDocument" class="video-responsive">
            <img :src="selected_content.file.file_link ? selected_content.file.file_link : selected_content.file"/>
          </div>

          <!--  Ses ve Video alanları -->
          <div
              v-if="[CATEGORY_IDS.videoDocument, CATEGORY_IDS.audioDocument].includes(+selected_content.file_category_id)"
              class="video-responsive">
            <template v-if="selected_content.is_video_interaction">
              <interactive-video-exam-player ref="interactiveVideoPlayerRef" :hashed-code="hashedCode"
                                             :item_content="item" :selected_content="selected_content"
                                             @complete-content="completeContent"
                                             @update-hash="hashedCode = $event"/>
            </template>
            <template v-else>
              <assignment-video-player ref="assignmentVideoPlayerRef" :hashed-code="hashedCode" :items="item"
                                       :selected_content="selected_content" @complete-content="completeContent"
                                       @update-hash="hashedCode = $event"/>
            </template>
          </div>

          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.exam">
            <ExamQuestionList v-if="showExamModal" :can-retake="canRetakeCurrentExam" :exam="currentExam"
                              :modal_name="'assignment_exam'"
                              :modal_title="currentExam.title" :read-only="isExamReadOnly"
                              @onClose="closeExam" @onSubmit="saveExam"/>
          </div>
          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.survey">
            <QuestionList :modal_name="'assignment_survey'" :modal_title="currentSurvey.name" :survey="currentSurvey"
                          @onClose="closeExam" @onSubmit="saveSurvey"/>
          </div>
          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.checkListItem">
            <CheckList :checkList="currentCheckList" :modal_name="'checklist'"
                       :modal_title="currentCheckList[0]?.description" @onClose="closeExam" @onSubmit="saveCheckList"/>
          </div>
          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.mission">
            <Mission :mission="missionDetail" :modal_name="'mission'" @onClose="closeExam" @onSubmit="saveMission"/>
          </div>
          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.informationContent">
            <div class="uk-width-5-5m uk-first-column" v-html="selected_content.information_content"></div>
          </div>
          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.videoUrl" class="ad-content-frame">
            <iframe :src="getEmbedUrl(selected_content.url)" :title="selected_content.title"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; camera; microphone"
                    allowfullscreen frameborder="0" height="100vh" width="100vw"></iframe>
          </div>
          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.pdfDocument" class="ad-content-frame">
            <!-- not: android native de pdf dosyası görüntülenmiyor, sadece download yapılıyor, bu sebbeple PdfViewer kullanıldı-->
            <PdfViewer :src="selected_content.file.file_link ? selected_content.file.file_link : selected_content.file"
                       mode="scroll" @reached-end="pdfScrollCompleted = true"/>
          </div>
          <div v-if="selected_content.file_category_id === CATEGORY_IDS.url" class="ad-content-frame">
            <!-- <iframe :src="selected_content.url" :title="selected_content.title"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; camera; microphone"
                    frameborder="0" height="100vh" width="100vw"></iframe> -->
            <div class="url-content-info">
              <i class="uil-link-alt url-icon"></i>
              <p class="url-description">{{
                  'Bu içerik harici bir bağlantıya yönlendirecektir.'
                }}</p>
              <a :href="selected_content.url" class="btn btn-primary btn-lg" rel="noopener noreferrer" target="_blank">
                <i class="uil-external-link-alt mr-2"></i> {{ 'Bağlantıya Git' }}
              </a>
            </div>
          </div>
          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.anzeraEducation" class="ad-content-frame">
            <default-loading v-if="!scormLoaded" minHeight="80vh"></default-loading>
            <iframe :src="externalScormPackageItemUrl" :title="selected_content.title"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; camera; microphone"
                    frameborder="0" height="100vh" width="100vw" @load="onScormIframeLoad"></iframe>
          </div>
          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.jitsi" class="ad-content-frame">
            <iframe :src="jitsiUrl" :title="selected_content.title"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; camera; microphone"
                    allowfullscreen frameborder="0" height="100vh" width="100vw"></iframe>
          </div>
          <div v-if="+selected_content.file_category_id === CATEGORY_IDS.scormPackage" class="ad-content-frame">
            <default-loading v-if="!scormLoaded" minHeight="80vh"></default-loading>
            <iframe :src="scormPackageItemUrl" :title="selected_content.title"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; camera; microphone"
                    allowfullscreen frameborder="0" @load="onScormIframeLoad"></iframe>
          </div>
          <!-- PowerPoint SCORM (is_powerpoint_scorm_file) - sayaç ve footer yok, backend kontrol ediyor -->
          <div v-if="selected_content.is_powerpoint_scorm_file" class="ad-content-frame">
            <default-loading v-if="!scormLoaded" minHeight="80vh"></default-loading>
            <iframe :src="scormPackageItemUrl" :title="selected_content.title"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; camera; microphone"
                    allowfullscreen frameborder="0" @load="onScormIframeLoad"></iframe>
          </div>
          <div
              v-if="[CATEGORY_IDS.powerpointDocument, CATEGORY_IDS.wordDocument].includes(+selected_content.file_category_id) && !selected_content.is_powerpoint_scorm_file"
              class="ad-content-frame">
            <div v-if="isCompletionTimeout" style="float:right">{{ $t('general.counter') }}: {{ counter }}</div>
            <iframe :src="fixedPPtWordFile"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; camera; microphone"
                    allowfullscreen frameborder="0" height="500" mozallowfullscreen scrolling="no" webkitallowfullscreen
                    width="1000"></iframe>
          </div>
        </div>
        <div v-if="showContentFooter" class="modal-footer content-modal-footer">
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-8">
              <template v-if="completedFlag">
                <div class="content-completing-indicator">
                  <span class="content-completing-spinner"></span>
                  <span>{{ $t("general.processing") }}...</span>
                </div>
              </template>
              <template v-else>
                <i class="icon-feather-check"></i>
                {{ $t("education.completed_the_content") }}
              </template>
            </div>
            <div v-show="!isCompletionTimeout" class="col-4">
              <span class="btn-night-mode-switch">
                <label :class="{ 'uk-switch--disabled': completedFlag || isPdfAndNotScrolled }" class="uk-switch"
                       for="default-1">
                  <input id="default-1" v-model="contentCompleted" :disabled="completedFlag || isPdfAndNotScrolled"
                         type="checkbox" @change="contentCompletedTrigger"/>
                  <div class="uk-switch-slider"></div>
                </label>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CERTIFICATE MODAL -->
    <CertificateModal :preview-link="pdf_preview_link" @download="handleToDownloadPdf"/>

    <!-- MAIN CONTENT -->
    <div class="ad-container">
      <AssignmentDetailsSkeleton v-if="assignment_loading"/>
      <div v-show="!assignment_loading">
        <div class="ad-layout">
          <!-- Sidebar -->
          <AssignmentSidebar :collection-visible="collectionModuleVisible" :completion-pct="completionPct" :item="item"
                             :progress-bar-class="progressBarClass" :progress-bar-style="progressBarStyle"
                             :progress-bar-tooltip="progressBarTooltip" :start-button="startButton"
                             @add-collection="is_add_collection = true"/>
          <!-- Main Content -->
          <div class="uk-width-2-3@m">
            <AssignmentDescription
              :item="item"
              :loading="assignment_loading"
              @instructor-click="openInstructorProfile"
            />

            <!-- Alerts -->
            <div v-if="successMessage != null" class="ad-alert ad-alert--success">
              <i class="icon-feather-check-circle"></i>
              <span>{{ successMessage }}</span>
              <a class="ad-alert-close" @click="successMessage = null"><i class="uil-times"></i></a>
            </div>
            <div v-if="errorMessage != null" class="ad-alert ad-alert--danger">
              <i class="icon-feather-alert-circle"></i>
              <span>{{ errorMessage }}</span>
              <a class="ad-alert-close" @click="errorMessage = null"><i class="uil-times"></i></a>
            </div>

            <!-- Tabs + Content -->
            <div class="ad-tab-wrapper">
              <div class="ad-tab-nav">
                <ul
                    uk-switcher="connect: #course-intro-tab ;animation: uk-animation-slide-right-medium, uk-animation-slide-left-medium">
                  <li>
                    <a href="javascript:void(0)">
                      <i class="uil-list-ul"></i>
                      <span>{{ $t("education.descriptions") }}</span>
                    </a>
                  </li>
                  <li v-if="item.has_feedbacks">
                    <a href="javascript:void(0)">
                      <i class="uil-comment-info-alt"></i>
                      <span>{{ $t("education.Sharing_Experience") }}</span>
                    </a>
                  </li>
                  <li v-if="item.has_present">
                    <a href="javascript:void(0)">
                      <i class="uil-trophy"></i>
                      <span>{{ $t("education.Gifts_and_Bests") }}</span>
                    </a>
                  </li>
                </ul>
              </div>
              <ul id="course-intro-tab" class="uk-switcher ad-tab-content">
                <!-- Course Contents -->
                <li>
                  <div class="ad-section-header">
                    <h4>{{ $t("education.about") }}</h4>
                  </div>
                  <p v-if="item.description && item.description !== 'null'" class="ad-description">
                    {{ item.description }}
                  </p>
                  <div v-if="item.hashtags && item.hashtags.length" class="ad-hashtags">
                    <span v-for="(hashtag, index) in item.hashtags" :key="'hashtag_' + index" class="ad-hashtag">#{{
                        hashtag
                      }}</span>
                  </div>

                  <!-- Collection -->
                  <AssignmentCollection :assignment-id="$route.params.id" :educations="item.educations"
                                        :visible="is_add_collection" @close="is_add_collection = false"
                                        @error="errorMessage = $event"
                                        @success="successMessage = $event"/>

                  <ContentList :can-be-watched-again="!!item.can_be_watched_again"
                               :can-open-contents-in-order="item.can_open_contents_in_order"
                               :content-programs="item.contents_programs" :current-item="item.current_item"
                               :exam-attempts="examAttempts"
                               :locked-items="item.locked_items" :unlocked-items="item.unlocked_items"
                               :user-content-completed="item.user_content_completed"
                               @instructor-click="openInstructorProfile"
                               @link-click="showContentModal($event)"
                               @show-certificate="showCertifcateModal($event)"/>
                </li>

                <!-- Feedbacks -->
                <AssignmentFeedbacks :comment-text="comment_text" :item="item" :user-photo="authUser.photo"
                                     @submit="makeComment" @update:commentText="comment_text = $event"/>

                <!-- Gifts -->
                <AssignmentGifts :auth-user-id="authUser.id" :gift-list="giftList" :item="item"
                                 :leader-list="leaderList"
                                 @go-link="goLink('user.show', $event)"/>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentList from "./components/ContentList.vue";
import DefaultLoading from "@/view/components/loading/DefaultLoading.vue";
import { mapGetters } from "vuex";
import {
  ERROR as REST_ERROR,
  GET_ITEM_DETAIL_BY_ID,
  LOADING as REST_LOADING,
  UPDATE_ITEM_BY_ID,
} from "@/core/services/store/REST.module";

import PdfViewer from "@/view/components/ui/PdfViewer.vue";
import AssignmentCollection from "./components/AssignmentCollection.vue";
import QuestionList from "@/view/components/survey/QuestionList.vue";
import EvaluationQuestionList from "@/view/components/survey/EvaluationQuestionList.vue";
import ExamQuestionList from "@/view/components/exam/ExamQuestionList.vue";
import CheckList from "@/view/components/checkList/CheckListDetail.vue";
import InteractiveVideoExamPlayer
  from "@/view/components/video/interactive-video-exam/interactive-video-exam-player.vue";
import Mission from "@/view/components/mission/MissionDetail.vue";
import Rating from "@/view/components/survey/Rating.vue";
import axios from "axios";
import { createInactivityTimer } from "@/utils/inactivityTimer";

import {
  GET_COUNT as NOTIFICATION_GET_COUNT,
  GET_ITEMS as NOTIFICATION_GET_ITEMS,
  MODULE_NAME as NOTIFICATION_MODULE_NAME,
} from "@/core/services/store/notification.module";
import { FETCH_MANDATORY_COMPLETIONS } from '@/core/services/store/mandatory.module';
import AssignmentVideoPlayer from "@/view/components/video/assignment-video/assignment-video-player.vue";
import CountdownModal from "@/view/components/CountdownModal.vue";
import ContentPlaybackDiagnostics from "@/view/components/ContentPlaybackDiagnostics.vue";
import { showSuccess, showError, showWarning } from "@/utils/alertUtils";
import { CATEGORY_IDS } from "@/core/constant/content-types";
import bridge from "@/core/services/bridge.service";
import native from "@/mobile/mobile.fileHandler";
import { toYouTubeEmbedUrl, isYouTubeUrl } from "@/utils/videojsUtils";
import { convertUTCToLocal } from "@/utils/timeUtils";
import AssignmentDescription from "./components/AssignmentDescription.vue";
import CertificateModal from "./components/CertificateModal.vue";
import AssignmentFeedbacks from "./components/AssignmentFeedbacks.vue";
import AssignmentGifts from "./components/AssignmentGifts.vue";
import AssignmentSidebar from "./components/AssignmentSidebar.vue";
import AssignmentDetailsSkeleton from "./components/AssignmentDetailsSkeleton.vue";
import PageHeader from "@/view/components/common/PageHeader.vue";
import InstructorProfileModal from "@/view/User/components/InstructorProfileModal.vue";
import instructorService, {
  normalizeInstructor,
} from "@/core/services/instructor.service";

const MANUEL_COMPLETE_CONTENT_IDS = [
  CATEGORY_IDS.visualDocument,
  CATEGORY_IDS.pdfDocument,
  CATEGORY_IDS.videoUrl,
  CATEGORY_IDS.url,
  CATEGORY_IDS.powerpointDocument,
  CATEGORY_IDS.wordDocument,
];

const API_URLS = {
  assignment: 'api/assignment/',
  certificate: 'api/assignment/user-certificate/',
  externalScorm: 'api/assignment/external-scorm/',
  scorm: 'api/content/get-scorm/',
  survey: 'api/assignment/survey/',
  rating: 'api/assignment/rating/',
  comment: 'api/assignment/comment/',
  completeContent: 'api/assignment/complete-content/',
  startContent: 'api/assignment/start-content/',
  gift: 'api/assignment/gift-list/',
  leader: 'api/assignment/leader-table/',
};

export default {
  name: "EducationDetails",
  components: {
    PageHeader,
    AssignmentDescription,
    AssignmentDetailsSkeleton,
    InstructorProfileModal,
    CertificateModal,
    AssignmentFeedbacks,
    AssignmentGifts,
    AssignmentSidebar,
    ContentList,
    AssignmentCollection,
    QuestionList,
    ExamQuestionList,
    EvaluationQuestionList,
    CheckList,
    Mission,
    Rating,
    DefaultLoading,
    InteractiveVideoExamPlayer,
    AssignmentVideoPlayer,
    CountdownModal,
    ContentPlaybackDiagnostics,
    PdfViewer
  },
  data() {
    return {
      counter: 0,
      completionTimerInterval: null,
      completionTimerTimeout: null,
      pdfLoading: true,
      pdfScrollCompleted: false,
      isCompletionTimeout: false,
      fixedPPtWordFile: '',
      scormLoaded: false,
      giftList: [],
      leaderList: [],
      externalScormPackageItemUrl: "",
      currentExam: "",
      currentSurvey: "",
      scormPackageItemUrl: "",
      is_add_collection: false,
      successMessage: null,
      errorMessage: null,
      item: {},
      comment_text: "",
      selected_content: null,
      exam_completed: false,
      pdf_preview_link: '',
      certificate_download_link: null,
      contentCompleted: false,
      showContentFooter: false,
      currentCheckList: '',
      missionDetail: {},
      jitsiUrl: '',
      inactivityTimer: null,
      networkCheckInterval: null,
      showExamModal: false,
      completedFlag: false,
      hashedCode: null, // hash code ile zaman + veri guncelleme vs işlemelri yapılacak
      assignmentId: null,
      suppressModalCloseEffects: false,
      selectedInstructor: null,
      instructorProfileRequestId: 0,
    };
  },
  computed: {
    ...mapGetters({
      assignment_loading: REST_LOADING,
    }),
    CATEGORY_IDS() {
      return CATEGORY_IDS;
    },
    isScormContent() {
      if (!this.selected_content) return false;
      const id = +this.selected_content.file_category_id;
      return id === CATEGORY_IDS.scormPackage
          || id === CATEGORY_IDS.anzeraEducation
          || this.selected_content.is_powerpoint_scorm_file;
    },
    isPdfAndNotScrolled() {
      if (!this.selected_content) return false;
      return +this.selected_content.file_category_id === CATEGORY_IDS.pdfDocument && !this.pdfScrollCompleted;
    },
    isCompletedWatchAgainExam() {
      return !!(this.item.can_be_watched_again && this.currentExam?.user_has_completed_exam);
    },
    /**
     * Hak varsa tamamlanmis sinav yeniden cozulebilir. Sinav GET'i de
     * `can_start_exam` donduruyor (atama detayindaki `exam_attempts` ile ayni
     * bilgi), o yuzden burada acilan sinavin kendi degeri kullaniliyor.
     */
    canRetakeCurrentExam() {
      return this.currentExam?.can_start_exam === true;
    },
    /**
     * Sinav salt-okunur acilir:
     *  - tamamlanmis sinav `can_be_watched_again` ile inceleniyorsa, veya
     *  - hak bitti (`can_start_exam: false`) ve icerik yalnizca goruntuleme
     *    icin acildiysa.
     * Ikisinde de cozme ve sonuc gonderme KAPALI.
     */
    isExamReadOnly() {
      return this.isCompletedWatchAgainExam || this.currentExam?.can_start_exam === false;
    },
    collectionModuleVisible() {
      const modules = JSON.parse(window.localStorage.getItem("modules")) ?? [];
      if (!modules.includes("my-collection")) return false;
      const institutionType = this.$store.getters.institutionType || 'softinya';
      if (institutionType === 'azcon') {
        return !!this.isAdmin;
      }
      return true;
    },
    startButton() {
      if (!this.item.educations?.length) return null;
      if (this.item.educations[0].file_category_id === CATEGORY_IDS.classroomEducation) return null;

      if (!this.item.is_start) {
        return {
          variant: 'danger',
          handler: null,
          labelKey: 'general.cantwatch',
          tooltip: 'Eğitim başlangıç tarihi henüz gelmemiştir.',
        };
      }

      if (this.item.completion_percentage !== 100 && !this.item.is_expired) {
        const continueTarget = this.resolveContinueTargetContent();

        // Acilacak bekleyen icerik kalmadi (tek acik icerik tamamlanmis bir
        // sinav tekrari olabilir — onu sidebar baslatmaz). Buton sessizce
        // olmesin diye kapatiyoruz; tekrar cozum liste satirindan yapilir.
        if (!continueTarget) return { variant: 'danger', handler: null, labelKey: 'general.cantwatch' };

        return this.withExamAttemptGuard({
          variant: 'success',
          handler: this.startFromUnlockedEducation,
          labelKey: this.item.completed_content_details?.length === 0
              ? 'education.Start_Education'
              : 'education.Continue_Where_I_Stay',
        }, continueTarget);
      }

      if (this.item.can_be_watched_again && this.item.completion_percentage === 100) {
        return this.withExamAttemptGuard(
            { variant: 'success', handler: this.startFirstEducation, labelKey: 'general.watch' },
            this.resolveFirstTargetContent()
        );
      }

      return { variant: 'danger', handler: null, labelKey: 'general.cantwatch' };
    },

    survey_name() {
      if (this.item.evaluation_survey) {
        return this.item.evaluation_survey.name;
      }
      if (this.item) {
        return this.item.name + " " + this.$t("general.evaluation_survey");
      }
    },
    restError() {
      return this.$store.getters[REST_ERROR];
    },
    completionPct() {
      const pct = this.item.completion_percentage;
      return pct == null ? 0 : Math.min(pct, 100);
    },
    progressBarClass() {
      const pct = this.item.completion_percentage;
      if (pct >= 75) return 'bg-success';
      if (pct >= 50) return 'bg-warning';
      return '';
    },
    progressBarStyle() {
      return `width:${this.completionPct}%`;
    },
    progressBarTooltip() {
      return `title:%${this.completionPct} ${this.$t('education.Completed')}; pos: top-center`;
    },
    /**
     * Sinav hak bilgisi. Anahtarlar CONTENT id'si — sinav id'si DEGIL — ve
     * JSON nesnesi oldugu icin string. `can_start_exam` hak ve atama
     * tarihlerini birlikte degerlendirir.
     */
    examAttempts() {
      return this.item.exam_attempts || {};
    },
  },

  methods: {
    async openInstructorProfile(rawInstructor) {
      if (!rawInstructor?.id) return;

      const instructorId = Number(rawInstructor.id);
      const requestId = ++this.instructorProfileRequestId;
      this.selectedInstructor = normalizeInstructor(rawInstructor);

      try {
        const instructor = await instructorService.getMine(instructorId);
        if (requestId !== this.instructorProfileRequestId) return;
        this.selectedInstructor = instructor;
      } catch (error) {
        // Atama detayından gelen temel eğitmen bilgisi modalda gösterilmeye devam eder.
      }
    },
    closeInstructorProfile() {
      this.instructorProfileRequestId += 1;
      this.selectedInstructor = null;
    },
    resetSelectedContentState() {
      this.selected_content = null;
      this.scormPackageItemUrl = "";
      this.externalScormPackageItemUrl = "";
      this.fixedPPtWordFile = "";
      this.jitsiUrl = "";
      this.showContentFooter = false;
      this.contentCompleted = false;
      this.scormLoaded = false;
      this.pdfScrollCompleted = false;
    },

    resetDetailState() {
      this.item = {};
      this.resetSelectedContentState();
      this.is_add_collection = false;
      this.comment_text = "";
      this.successMessage = null;
      this.errorMessage = null;
      this.giftList = [];
      this.leaderList = [];
      this.exam_completed = false;
      this.hashedCode = null;
      this.currentExam = "";
      this.currentSurvey = "";
      this.currentCheckList = "";
      this.missionDetail = {};
      this.showExamModal = false;
      this.completedFlag = false;
      this.clearCompletionTimer();
      this.stopInactivityTimer();
      this.stopNetworkCheck();
    },

    closeContentModalSilently() {
      if (!this.selected_content) return;

      this.suppressModalCloseEffects = true;

      if (typeof UIkit !== "undefined") {
        const modal = UIkit.modal("#content_modal");
        if (modal) {
          modal.hide();
          return;
        }
      }

      this.suppressModalCloseEffects = false;
    },

    loadAssignmentFromRoute(assignmentId) {
      if (!assignmentId) {
        this.$router.go(-1);
        return;
      }

      this.closeContentModalSilently();
      this.assignmentId = assignmentId;
      this.resetDetailState();
      this.getAssignmentItem(assignmentId);
    },

    getEmbedUrl(url) {
      if (isYouTubeUrl(url)) {
        return toYouTubeEmbedUrl(url);
      }
      return url;
    },
    // sections[].contents[] içindeki nesnelerde is_powerpoint_scorm_file alanı null gelir.
    // Bu metod, contents[] (flat array) içindeki doğru değerleri sections[].contents[]'e kopyalar.
    enrichPowerpointScormFlag() {
      if (!this.item?.contents_programs) return;

      for (const content_program of this.item.contents_programs) {
        if (!Array.isArray(content_program.contents) || !Array.isArray(content_program.sections)) continue;

        // contents[] dizisinden id → is_powerpoint_scorm_file haritası oluştur
        const pptScormMap = new Map();
        for (const content of content_program.contents) {
          if (content.is_powerpoint_scorm_file != null) {
            pptScormMap.set(content.id, content.is_powerpoint_scorm_file);
          }
        }

        // Haritadaki değerleri sections[].contents[] içindeki nesnelere aktar
        for (const section of content_program.sections) {
          if (Array.isArray(section.contents)) {
            for (const content of section.contents) {
              if (pptScormMap.has(content.id)) {
                content.is_powerpoint_scorm_file = pptScormMap.get(content.id);
              }
            }
          }
        }
      }
    },

    loadedIframePdf() {
      this.pdfLoading = false;
    },
    async contentCompletedTrigger() {
      if (!this.completedFlag && this.selected_content) {
        try {
          await this.completeContent(this.selected_content);
        } catch (error) {
          console.error("completeContent error:", error);
        } finally {
          this.completedFlag = false;
        }
      }
      setTimeout(() => {
        UIkit.modal("#content_modal").hide();
      }, 400);
    },


    goLink(name, params) {
      if (params)
        this.$router.push({ name: name, params: { id: params } });
      UIkit.modal(this.$refs["modalRef"]).hide(0);
    },

    saveEvaluationSurvey(data, callback) {
      this.$store
          .dispatch(UPDATE_ITEM_BY_ID, {
            url: API_URLS.survey + this.assignmentId,
            contents: data,
            acceptPromise: false,
          })
          .then((result) => {
            if (result.status) {
              this.item.survey_count = 1;
              this.$modal.hide("survey_list_modal");

            }
            callback(result);
            return true;
          });
    },
    saveSurvey(data, callback) {
      this.$store
          .dispatch(UPDATE_ITEM_BY_ID, {
            url: `${API_URLS.assignment}${this.assignmentId}/content/${this.selected_content.id}/survey/result`,
            contents: { ...data, hashed: this.hashedCode },
            acceptPromise: false,
          })
          .then((result) => {
            if (result.status) {
              this.$modal.hide("content_modal");
            }
            callback(result);
            return true;
          });
    },

    closeExam(data) {
      if (data) {
        this.showExamModal = false;
        UIkit.modal("#content_modal").hide();
      }
    },

    /**
     * Sonuc gonderiminde HTTP 422 -> `errors.exam` icinde hata KODU gelir
     * (Laravel sekli: { message, errors: { exam: ["kod"] } }).
     * Bu hatalarda sonuc kaydedilmez ve hak tuketilmez.
     */
    resolveExamResultError(result) {
      const examErrors = result?.error?.errors?.exam;
      const code = Array.isArray(examErrors) ? examErrors[0] : examErrors;

      const messageKeys = {
        exam_attempt_limit_reached: 'general.exam_attempt_limit_reached',
        assignment_expired: 'general.assignment_expired',
        assignment_not_started: 'general.assignment_not_started',
      };

      return messageKeys[code] ? this.$t(messageKeys[code]) : null;
    },

    saveExam(data, callback) {
      // Salt-okunur acilan sinavda (hak bitti / tamamlanmis sinav inceleniyor)
      // sonuc gonderilmez. ExamQuestionList zaten gondermiyor; bu guard DOM
      // mudahalesine karsi son savunma.
      if (this.isExamReadOnly) {
        showError(this.$t('general.no_remaining_attempt'), 8000);
        callback({ status: false });
        return;
      }

      this.$store
          .dispatch(UPDATE_ITEM_BY_ID, {
            url: `${API_URLS.assignment}${this.assignmentId}/content/${this.selected_content.id}/exam/result`,
            contents: { ...data, hashed: this.hashedCode },
            acceptPromise: false,
          })
          .then((result) => {
            if (result.status) {
              const responseData = result.data;

              // Sınav tamamlandı
              this.exam_completed = true;

              // başarısız
              // if (responseData.has_error) {
              //   const userResult = responseData.user_result;
              //   const failMessage = this.$t(`exam.${responseData.message}`) +
              //       ` (${userResult.user_right_answer_count}/${userResult.question_count} ${this.$t('general.correct')})`;

              //   showError(failMessage, 8000);
              // } else {
              //   // başarılı
              //   const userResult = responseData.user_result;
              //   const successMessage = this.$t(`exam.${responseData.message}`) +
              //       `(${userResult.user_right_answer_count}/${userResult.question_count} ${this.$t('general.correct')})`;

              //   showSuccess(successMessage, 5000);
              // }
            } else {
              // Sonuç KAYDEDILMEDI. (Başarısız sınav 200 + has_error ile
              // kaydedilir ve yukarıdaki dala düşer — burası gerçek hata.)
              let errorMessage = this.resolveExamResultError(result);

              // Eski yanıt şekli: { message: { message: "<kod>" } }
              if (!errorMessage && typeof result.error?.message === 'object' && result.error.message.message) {
                errorMessage = this.$t(`exam.${result.error.message.message}`);
              }

              showError(errorMessage || this.$t(`errors.error_occurred`), 8000);
            }
            callback(result);
            return true;
          })
    },
    saveCheckList(data, callback) {
      this.$store
          .dispatch(UPDATE_ITEM_BY_ID, {
            url: `${API_URLS.assignment}${this.assignmentId}/content/${this.selected_content.id}/checkList/result`,
            contents: { ...data, hashed: this.hashedCode },
            acceptPromise: false,
          })
          .then((result) => {
            this.exam_completed = true;
            callback(result);
            return true;
          });
    },
    saveMission(data, callback) {
      data.userAnswer.append("hashed", this.hashedCode);
      this.$store
          .dispatch(UPDATE_ITEM_BY_ID, {
            url: `${API_URLS.assignment}${this.assignmentId}/content/${this.selected_content.id}/mission/result`,
            contents: data.userAnswer,
            acceptPromise: false,
          })
          .then((result) => {
            if (result?.status) {
              this.exam_completed = true;
            }
            callback(result);
            return true;
          })
          .catch(() => {
            callback({ status: false, error: { message: "errors.error_occurred" } });
          });
    },
    saveRating(data, callback) {
      let formData = new FormData();
      formData.append("rating", data.rating);
      formData.append("comment", data.comment);
      this.$store
          .dispatch(UPDATE_ITEM_BY_ID, {
            url: API_URLS.rating + this.assignmentId,
            contents: formData,
          })
          .then((result) => {
            if (result && result.status) {
              this.item.total_rating = result.data.total_rating;
              this.$modal.hide("rate_education_modal");
            }
            callback(this.restError);
            return true;
          });
    },
    makeComment() {
      if (this.comment_text.length < 2) {
        this.errorMessage = this.$t("validation.required_field").replace(
            ":NAME",
            this.$t("assignment.comment")
        );
        return false;
      }
      let formData = new FormData();
      formData.append("comment", this.comment_text);
      this.$store
          .dispatch(UPDATE_ITEM_BY_ID, {
            url: API_URLS.comment + this.assignmentId,
            contents: formData,
          })
          .then((result) => {
            if (!this.restError) {
              this.comment_text = "";
              if (Object.keys(result.data).length)
                this.item.approved_comments.unshift(result.data);
              this.successMessage = this.$t("general.successfully_created");
            } else this.errorMessage = this.restError;
          });
    },
    resetMessages() {
      this.errorMessage = null;
      this.successMessage = null;
    },
    showCertifcateModal(content_id) {
      this.$store
          .dispatch(GET_ITEM_DETAIL_BY_ID, {
            url: `${API_URLS.certificate}${this.assignmentId}/${content_id}`,
            acceptPromise: false,
          })
          .then((result) => {
            if (!this.restError && result.status) {
              this.pdf_preview_link = result.data.pdf_preview_link;
              this.certificate_download_link = result.data.pdf_download_link;
              UIkit.modal("#assignment_certificate_modal").show();
            } else this.errorMessage = this.restError;
          });
    },
    handleToDownloadPdf() {
      const downloadUrl = this.certificate_download_link;

      if (!downloadUrl) {
        showError(this.$t("general.download_error") || "Dosya indirilemedi");
        return;
      }

      if (bridge.isNative) {
        native.downloadFile(downloadUrl, "sertifika.pdf", "application/pdf");
      } else {
        window.open(downloadUrl, "_blank", "noopener,noreferrer");
      }

      UIkit.modal("#assignment_certificate_modal").hide();
    },
    clearCompletionTimer() {
      if (this.completionTimerInterval) {
        clearInterval(this.completionTimerInterval);
        this.completionTimerInterval = null;
      }
      if (this.completionTimerTimeout) {
        clearTimeout(this.completionTimerTimeout);
        this.completionTimerTimeout = null;
      }
    },
    startCompletionTimer(minutes) {
      this.clearCompletionTimer();

      this.isCompletionTimeout = true;
      this.counter = minutes * 60;

      this.completionTimerInterval = setInterval(() => {
        this.counter--;
        if (this.counter <= 0) {
          this.counter = 0;
          this.clearCompletionTimer();
          this.isCompletionTimeout = false;
        }
      }, 1000);

      this.completionTimerTimeout = setTimeout(() => {
        this.isCompletionTimeout = false;
        this.clearCompletionTimer();
      }, minutes * 60 * 1000);
    },

    resetContentState(selected_content) {
      this.clearCompletionTimer();
      this.contentCompleted = false;
      this.isCompletionTimeout = false;
      this.counter = 0;
      this.showContentFooter = false;
      this.scormLoaded = false;
      this.pdfScrollCompleted = false;
      this.selected_content = selected_content;
    },

    /** Icerik bir sinavsa hak kaydini döndürür; degilse / kayit yoksa null. */
    getExamAttempt(content) {
      if (!content || +content.file_category_id !== CATEGORY_IDS.exam) return null;
      return this.examAttempts[String(content.id)] ?? null;
    },

    /**
     * Hak bitmis ya da atama tarihleri uygun degil. `=== false` BILEREK:
     * alani henuz dondurmeyen bir backend'de icerik kilitlenmesin.
     */
    isExamAttemptBlocked(content) {
      if (this.getExamAttempt(content)?.can_start_exam !== false) return false;

      // Hak bitti. `can_be_watched_again` acikken backend sinavi GORUNTULEME
      // icin donduruyor; icerik acilir ama salt-okunur olur (isExamReadOnly).
      return !this.item.can_be_watched_again;
    },

    /**
     * Sidebar'daki tek aksiyon butonu, acacagi icerik hak biten bir sinavsa
     * kapatilir. Atamadaki DIGER sinavlarin hakki bitse bile buton acik kalir;
     * belirleyici olan yalnizca o tiklamada acilacak icerik.
     */
    withExamAttemptGuard(button, targetContent) {
      if (!this.isExamAttemptBlocked(targetContent)) return button;

      return {
        variant: 'danger',
        handler: null,
        labelKey: 'general.cantwatch',
        tooltip: this.$t('general.no_remaining_attempt'),
      };
    },

    /** `startFromUnlockedEducation`in acacagi icerik. */
    resolveContinueTargetContent() {
      const currentTarget = this.findContentById(this.item.current_item);
      if (currentTarget && !this.isExamRetake(currentTarget)) return currentTarget;

      // current_item tamamlanmis bir sinava isaret ediyorsa siradaki gercek
      // bekleyen icerige geciyoruz — sidebar tekrar sinav baslatmaz.
      return this.findFirstUnlockedContent();
    },

    /**
     * Tamamlanmis ama hak kaldigi icin tekrar acilabilen sinav.
     *
     * Tekrar cozum YALNIZCA liste satirina tiklanarak yapilir; soldaki
     * "kaldigim yerden devam et" butonu (.ad-actions) tekrar sinav cozumu
     * TETIKLEMEZ. Bu yuzden sidebar hedef cozumlemesi boyle icerikleri atlar.
     */
    isExamRetake(content) {
      if (!content || !this.getExamAttempt(content)) return false;
      return !!this.item.completed_content_details?.[String(content.id)]?.completed_at;
    },

    /** `startFirstEducation`in acacagi icerik — dal secimi onunla birebir ayni. */
    resolveFirstTargetContent() {
      const programs = this.item.contents_programs;

      if (Array.isArray(programs) && programs.length) {
        const first = programs[0];
        if (!first.is_program) return first;

        const firstSectionContent = first.sections?.[0]?.contents?.[0];
        if (firstSectionContent) return firstSectionContent;
      }

      // startFirstEducation'in son care dali
      return this.item.educations?.[0] ?? null;
    },

    /** contents_programs icinde — program ise section'lari da gezerek — icerik arar. */
    findContentById(contentId) {
      if (contentId == null || !Array.isArray(this.item.contents_programs)) return null;

      for (const program of this.item.contents_programs) {
        if (!program.is_program) {
          if (program.id === contentId) return program;
          continue;
        }
        for (const section of program.sections || []) {
          const found = (section.contents || []).find((content) => content.id === contentId);
          if (found) return found;
        }
      }

      return null;
    },

    canOpenContent(content) {
      if (content.file_category_id === CATEGORY_IDS.classroomEducation)
        return false;

      /**
       * SADECE sinav icerikleri icin: yeniden girilebilirligi `exam_attempts`
       * belirler, "tamamlanmis olmak" degil. Hak varsa (ornegin
       * attempt_limit: null) sinav tamamlanmis olsa bile tekrar girilip
       * cozulebilir; hak bittiyse acilmaz.
       *
       * Sinav disi iceriklerde `examAttempt` null kalir ve asagidaki
       * kontrollerin hicbiri degismez.
       */
      const examAttempt = this.getExamAttempt(content);

      if (this.isExamAttemptBlocked(content)) return false;

      const now = new Date().getTime();
      const startTime = new Date(convertUTCToLocal(this.item.start_date)).getTime();
      const endTime = new Date(convertUTCToLocal(this.item.end_date)).getTime();
      const beforeStart = startTime - now > 0;
      const afterEnd = endTime - now < 0;

      // Atama penceresi — sinavlar icin de gecerli. (BE `can_start_exam`i
      // uretirken atama tarihlerini de hesaba katiyor; bu kontrol onunla
      // cakismiyor, dogruluyor.)
      if (
          beforeStart ||
          (afterEnd && !this.item.can_be_watched_again) ||
          (!this.item.is_completed && this.item.is_expired && !this.item.can_be_watched_again)
      ) return false;

      // Atama %100 tamamlandi. Sinavlarda belirleyici olan HAK oldugu icin bu
      // kontrol yalnizca sinav disi icerikler icin uygulanir.
      if (!examAttempt
          && !this.item.can_be_watched_again
          && this.item.is_completed
          && this.item.completion_percentage === 100) return false;

      if (
          content?.pivot?.timed_content_type === 'timed_content' &&
          (
              new Date(convertUTCToLocal(content?.pivot?.starts_at)).getTime() - now > 0 ||
              new Date(convertUTCToLocal(content?.pivot?.ends_at)).getTime() - now < 0
          )
      ) return false;

      // Icerik tamamlandi. Sinavlarda tekrar girisi `can_start_exam` belirledigi
      // icin `completed_at` kontrolu sinavlara UYGULANMAZ.
      if (!examAttempt) {
        const completedDetail = this.item.completed_content_details?.[String(content.id)];
        const isCompleted = completedDetail && !!completedDetail.completed_at;
        if (isCompleted && !this.item.can_be_watched_again) return false;
      }

      return true;
    },

    openPlaybackDiagnostics() {
      if (this.$refs.contentPlaybackDiagnostics) {
        this.$refs.contentPlaybackDiagnostics.show();
      }
    },

    onScormIframeLoad() {
      this.scormLoaded = true;
    },

    showContentModal(selected_content) {
      // Liste zaten aksiyonu kapatiyor; buraya yalnizca programatik yollardan
      // (sidebar "Basla" butonu gibi) gelinebilir, o yuzden sessiz kalmayalim.
      if (this.isExamAttemptBlocked(selected_content)) {
        showWarning(this.$t('general.no_remaining_attempt'));
        return;
      }

      if (!this.canOpenContent(selected_content)) return;

      this.missionDetail = selected_content.content_mission;

      if (selected_content.file_category_id === CATEGORY_IDS.checkListItem && !selected_content.is_program) {
        this.currentCheckList = [...selected_content.content_check_list_items];
      }

      this.resetContentState(selected_content);

      if (!this.item.is_completed) {
        this.setStartedAt();
      }
      this.startContent(selected_content);
      if (MANUEL_COMPLETE_CONTENT_IDS.includes(selected_content.file_category_id)) {
        // Scorm pptx ise: sayaç yok, footer yok (backend kontrol ediyor)
        if (selected_content.is_powerpoint_scorm_file) {
          this.showContentFooter = false;
        } else {
          if (selected_content.completion_timeout) {
            this.startCompletionTimer(selected_content.completion_timeout);
          }
          this.showContentFooter = true;
        }
      }

      if (!this.setupContentByType(selected_content)) return;

      UIkit.modal("#content_modal").show();
    },

    // İçerik tipine göre gerekli state'i hazırlar.
    // false döndürürse modal açılmaz (dış kaynaklar yeni sekmede açılır).
    setupContentByType(content) {
      const id = content.file_category_id;

      // Dış kaynak → yeni sekmede aç, modal açma
      if (content.external_status) {
        window.open(content.url || '', '_blank');
        return false;
      }

      // Webinar → yeni sekmede aç, modal açma
      if (id === CATEGORY_IDS.webinar) {
        window.open(this.item?.educations[0].webinar?.join_url, '_blank');
        return false;
      }

      // Provider içerik (LinkedIn vb.) → footer gizle
      if (content.provider) {
        this.showContentFooter = false;
      }

      // SCORM
      if (id === CATEGORY_IDS.scormPackage || (id === CATEGORY_IDS.powerpointDocument && content.is_powerpoint_scorm_file)) {
        this.getScormEducationUrl(content.id);
        return true;
      }

      // PPT / Word (normal, SCORM'suz)
      if ([CATEGORY_IDS.powerpointDocument, CATEGORY_IDS.wordDocument].includes(id) && !content.is_powerpoint_scorm_file) {
        this.fixedPPtWordFile = 'https://view.officeapps.live.com/op/embed.aspx?src=' + content.file.file_link + '?postMessageEvents=true';
        return true;
      }

      // Anzera (harici SCORM)
      if (id === CATEGORY_IDS.anzeraEducation) {
        this.getExternalScormUrl(content.id);
        return true;
      }

      // Jitsi
      if (id === CATEGORY_IDS.jitsi) {
        this.jitsiUrl = content.url;
        return true;
      }

      // Sınav
      if (id === CATEGORY_IDS.exam) {
        this.exam_completed = false;
        this.showExamModal = false;
        this.getExamContent(content.id);
        return true;
      }

      // Anket
      if (id === CATEGORY_IDS.survey) {
        this.getSurveyContent(content.id);
        return true;
      }

      // Bilgi içeriği → footer göster
      if (id === CATEGORY_IDS.informationContent) {
        this.showContentFooter = true;
        return true;
      }

      return true;
    },

    setStartedAt() {
      this.$store.dispatch(UPDATE_ITEM_BY_ID, {
        url: `${API_URLS.assignment}started/${this.assignmentId}`,
        contents: { type: "started" },
      });
    },
    setCompletedAt() {
      this.$store.dispatch(UPDATE_ITEM_BY_ID, {
        url: `${API_URLS.assignment}completed/${this.assignmentId}`,
        contents: { type: "completed" },
      });
    },
    async completeContent(education) {
      this.completedFlag = true;

      try {
        // İçerik süresi dolmuşsa durdur
        if (this.item.is_expired) return false;

        // Manuel tamamlanacak içerikler
        if (
            MANUEL_COMPLETE_CONTENT_IDS.includes(education?.file_category_id) &&
            !this.contentCompleted
        ) {
          return false;
        }

        const formData = new FormData();
        formData.append("hashed", this.hashedCode);

        const result = await this.$store.dispatch(UPDATE_ITEM_BY_ID, {
          url: `${API_URLS.completeContent}${this.assignmentId}/${education?.id}`,
          contents: formData,
        });

        if (result.status) {
          const data = result.data;

          this.item.completion_percentage = data.completion_percentage;
          this.item.user_content_completed = data.user_content_completed;
          this.item.user_content_completed_count = data.user_content_completed_count;
          this.item.locked_items = data.locked_items;
          this.item.unlocked_items = data.unlocked_items;
          this.item.current_item = data.current_item;
          // Tamamlandıysa bitiş zamanı kaydet
          if (this.item.is_completed) {
            this.setCompletedAt();
          }
        } else {
          this.errorMessage = this.restError;
        }

        // Atamaları güncelle
        await this.getAssignmentItem();

        await this.$store.dispatch(
            NOTIFICATION_MODULE_NAME + "/" + NOTIFICATION_GET_COUNT,
            {}
        );
        await this.$store.dispatch(
            NOTIFICATION_MODULE_NAME + "/" + NOTIFICATION_GET_ITEMS,
            {}
        );


        // Zorunlu eğitimleri güncelle
        await this.$store.dispatch(`mandatory/${FETCH_MANDATORY_COMPLETIONS}`);
      } catch (error) {
        console.error("completeContent error:", error);
        this.errorMessage = error.message || "Beklenmeyen bir hata oluştu.";
      } finally {
        // İşlem her durumda tamamlandı olarak işaretlensin
        this.completedFlag = false;
      }
    },

    startContent(education) {
      if (this.item.is_expired) return;

      this.$store
          .dispatch(UPDATE_ITEM_BY_ID, { url: `${API_URLS.startContent}${this.assignmentId}/${education.id}` })
          .then((result) => {
            if (result.status) {
              this.hashedCode = result.data;
            } else {
              this.errorMessage = this.restError;
            }
          });
    },
    showSurveyModal() {
      const { is_completed, survey_required, survey_count, educations } = this.item;
      if (!is_completed || !survey_required || !educations.length || survey_count !== 0) return;

      if (this.selected_content != null) {
        const lastId = educations[educations.length - 1].id;
        if (lastId === this.selected_content.id) this.$modal.show("survey_list_modal");
      } else {
        this.$modal.show("survey_list_modal");
      }
    },
    setModalListener() {
      const self = this;

      // Modal açıkken geri tuşuna basılırsa önce modal kapanır (web & mobil uyumlu)
      this._contentModalHistoryState = null;
      this._contentModalPopstateHandler = function () {
        if (self._contentModalHistoryState && self.selected_content) {
          self._contentModalHistoryState = null;
          UIkit.modal("#content_modal").hide();
        }
      };
      window.addEventListener("popstate", this._contentModalPopstateHandler);

      $("#content_modal").on({
        "show.uk.modal": function () {
          // Modal açılınca orientation kilidini kaldır (yan çevirme aktif)
          bridge.send('ORIENTATION_LOCK', { orientation: 'default' });

          // iframe içeren içerikler için inaktivite timer'ını başlatma
          const iframeContentTypes = [
            CATEGORY_IDS.pdfDocument,
            CATEGORY_IDS.powerpointDocument,
            CATEGORY_IDS.wordDocument,
            CATEGORY_IDS.scormPackage,
            CATEGORY_IDS.videoUrl,
          ];

          // Seçili içerik varsa ve iframe içeriği değilse inaktivite süresi başlat
          if (self.selected_content) {
            const fileId = +self.selected_content.file_category_id;
            const isIframeContent = iframeContentTypes.includes(fileId) || self.selected_content.is_powerpoint_scorm_file;

            if (!isIframeContent) {
              console.log('✅ Inactivity timer başlatılıyor (iframe içeriği değil)');
              self.startInactivityTimer();
            } else {
              console.log('⏸️ Inactivity timer başlatılmadı (iframe içeriği)');
            }
          }
          // Ağ bağlantısı kontrolünü başlat
          self.startNetworkCheck();

          // Geri tuşu desteği: history state ekle
          self._contentModalHistoryState = { contentModal: true, id: Date.now() };
          history.pushState(self._contentModalHistoryState, "");
        },

        "hide.uk.modal": function () {
          // Route değişimi sırasında modal sessizce kapatılıyorsa, side-effect'leri atla
          if (self.suppressModalCloseEffects) {
            self.suppressModalCloseEffects = false;
            self._contentModalHistoryState = null;
            bridge.send('ORIENTATION_LOCK', { orientation: 'portrait' });
            self.stopInactivityTimer();
            self.stopNetworkCheck();
            self.resetSelectedContentState();
            return;
          }

          // Geri tuşu desteği: history state temizle
          if (self._contentModalHistoryState && history.state && history.state.contentModal && history.state.id === self._contentModalHistoryState.id) {
            history.back();
          }
          self._contentModalHistoryState = null;

          // Orientation kilidini kaldır (portrait'e dön)
          bridge.send('ORIENTATION_LOCK', { orientation: 'portrait' });

          // İnaktivite zamanlayıcısını durdur
          self.stopInactivityTimer();

          // Sınav modal'ını kapat
          self.showExamModal = false;

          // İçerik seçilmemişse çık
          if (!self.selected_content) {
            return;
          }

          const fileId = +self.selected_content.file_category_id;
          const isVideo = [CATEGORY_IDS.audioDocument, CATEGORY_IDS.videoDocument].includes(fileId);

          // Sınav tipi içerik tamamlanmadıysa çık
          if (fileId === CATEGORY_IDS.exam && self.exam_completed !== true) {
            return false;
          }

          // Video içerikleri — player üzerinden konum güncelle
          if (isVideo) {
            const playerRef = self.$refs.assignmentVideoPlayerRef || self.$refs.interactiveVideoPlayerRef;
            if (playerRef) {
              playerRef.updateVideoWhereStay();
            }
          }

          // Seçili içeriği sıfırla
          self.selected_content = null;
          self.externalScormPackageItemUrl = "";
          self.scormPackageItemUrl = "";

          // Ağ kontrolünü durdur
          self.stopNetworkCheck();

          // Modal kapandığında veriyi yenile (completion oranı güncellensin)
          setTimeout(() => {
            self.getAssignmentItem();
          }, 300);
        },
      });
    },

    itemGifts() {
      axios.get(API_URLS.gift + this.assignmentId).then((response) => {
        this.giftList = response.data;
      });
    },
    itemLeaders() {
      axios.get(API_URLS.leader + this.assignmentId).then((response) => {
        this.leaderList = response.data;
      });
    },
    getAssignmentItem(assignmentId = this.assignmentId) {
      if (!assignmentId) {
        this.$router.push('/dashboard');
        return;
      }

      this.$store
          .dispatch(GET_ITEM_DETAIL_BY_ID, {
            url: API_URLS.assignment + assignmentId,
            acceptPromise: false,
            showLoading: true,
          })
          .then((result) => {
            if (result && result.status) {
              this.item = result.data;
              this.enrichPowerpointScormFlag();

              if (this.item.has_present) this.itemGifts();
              if (this.item.appear_top) this.itemLeaders();

              this.showSurveyModal();
            } else {
              this.$router.push('/dashboard');
            }
          })
          .catch((error) => {
            console.error(error);
            this.$router.push('/dashboard');
          });
    },
    startFromUnlockedEducation() {
      // current_item; bulunamazsa ilk açık (kilitli olmayan) içerik.
      // Hedef cozumlemesi `startButton`un hak kontrolu ile ayni olsun diye
      // `resolveContinueTargetContent` uzerinden yapiliyor.
      const foundContent = this.resolveContinueTargetContent();
      if (foundContent) {
        this.showContentModal(foundContent, false);
      }
      return false;
    },
    startFirstEducation() {
      let item = this.item;

      // Program içindeki ilk içeriği bul
      if (item.contents_programs && item.contents_programs.length > 0) {
        let firstProgram = item.contents_programs[0];
        if (firstProgram.is_program && firstProgram.sections && firstProgram.sections.length > 0) {
          let firstSection = firstProgram.sections[0];
          if (firstSection.contents && firstSection.contents.length > 0) {
            this.showContentModal(firstSection.contents[0], false);
            return true;
          }
        } else if (!firstProgram.is_program) {
          // Program değilse doğrudan içeriği göster
          this.showContentModal(firstProgram, false);
          return true;
        }
      }

      this.showContentModal(item.educations[0], false);
      return true;
    },
    getExternalScormUrl(content_id) {
      this.$store
          .dispatch(GET_ITEM_DETAIL_BY_ID, {
            url: `${API_URLS.externalScorm}${this.assignmentId}/content/${content_id}`,
            acceptPromise: false,
          })
          .then((result) => {
            if (result.status) this.externalScormPackageItemUrl = result.data;
          });
    },
    getExamContent(content_id) {
      this.$store
          .dispatch(GET_ITEM_DETAIL_BY_ID, {
            url: `${API_URLS.assignment}${this.assignmentId}/content/${content_id}/exam`,
            acceptPromise: false,
          })
          .then((result) => {
            if (result.status) {
              this.currentExam = result.data;
              this.exam_completed = !!(this.item.can_be_watched_again && result.data?.user_has_completed_exam);
              this.showExamModal = true;
            }
          });
    },
    getSurveyContent(content_id) {
      this.$store
          .dispatch(GET_ITEM_DETAIL_BY_ID, {
            url: `${API_URLS.assignment}${this.assignmentId}/content/${content_id}/survey`,
            acceptPromise: false,
          })
          .then((result) => {
            if (result.status) this.currentSurvey = result.data;
          });
    },

    getScormEducationUrl(content_id) {
      this.$store
          .dispatch(GET_ITEM_DETAIL_BY_ID, {
            url: `${API_URLS.scorm}${this.assignmentId}/content/${content_id}`,
            acceptPromise: false,
          })
          .then((result) => {
            if (result.status) this.scormPackageItemUrl = result.data;
          });
    },
    findFirstUnlockedContent() {
      // Artik `startButton` computed'inden de cagriliyor; item henuz
      // yuklenmemisken patlamamasi icin guard sart.
      if (!Array.isArray(this.item.contents_programs)) return null;
      const lockedItems = this.item.locked_items || [];

      // Tamamlanmis icerik `locked_items`ta OLMADIGI icin buraya dusebiliyor;
      // tamamlanmis sinavlari atliyoruz ki sidebar tekrar sinav baslatmasin.
      const isSelectable = (content) =>
          !lockedItems.includes(content.id) && !this.isExamRetake(content);

      // contents_programs içinde ilk açık (kilitli olmayan) içeriği bul
      for (let i = 0; i < this.item.contents_programs.length; i++) {
        let content = this.item.contents_programs[i];

        if (content.is_program) {
          // Program içindeki içerikleri kontrol et
          for (let j = 0; j < (content.sections || []).length; j++) {
            let section = content.sections[j];
            for (let k = 0; k < (section.contents || []).length; k++) {
              let sectionContent = section.contents[k];
              // Kilitli olmayan ilk içeriği bul
              if (isSelectable(sectionContent)) {
                return sectionContent;
              }
            }
          }
        } else {
          // Program olmayan içeriği kontrol et
          if (isSelectable(content)) {
            return content;
          }
        }
      }
      return null;
    },

    //ekran süresi izleme
    startInactivityTimer() {
      // Önce mevcut timer'ı durdur
      this.stopInactivityTimer();

      this.inactivityTimer = createInactivityTimer({
        timeout: 900000, // 15 dakika
        onInactive: () => {
          // Hareketsizlik tespit edildiğinde countdown modal'ını aç
          if (this.$refs.countdownModal && this.selected_content) {
            this.$refs.countdownModal.show();
          }
        }
      });
      this.inactivityTimer.start();
    },

    stopInactivityTimer() {
      if (this.inactivityTimer) {
        this.inactivityTimer.stop();
        this.inactivityTimer = null;
      }
    },

    startNetworkCheck() {
      // Modal açıkken internet bağlantısını kontrol et
      this.networkCheckInterval = setInterval(() => {
        if (!navigator.onLine && this.selected_content) {
          this.closeModalDueToNetworkIssue();
        }
      }, 1000); // Her saniye kontrol et
    },

    stopNetworkCheck() {
      if (this.networkCheckInterval) {
        clearInterval(this.networkCheckInterval);
        this.networkCheckInterval = null;
      }
    },

    closeModalDueToNetworkIssue() {
      // Modal'ı kapat
      UIkit.modal("#content_modal").hide();

      // Uyarı göster
      const message = this.$t('general.modal_closed_due_to_network');
      showWarning(message, 0);

      // Temizlik
      this.selected_content = null;
      this.externalScormPackageItemUrl = "";
      this.scormPackageItemUrl = "";
    },

    onInactivityTimeout() {
      // Inactivity timeout'ta content modal'ı kapat
      if (this.selected_content) {
        UIkit.modal("#content_modal").hide();
      }
    },

    onInactivityContinue() {
      // Kullanıcı devam etti, inactivity timer'ı yeniden başlat
      // Sadece modal açıkken timer'ı başlat
      if (this.selected_content) {
        this.startInactivityTimer();
      }
    },

  },
  watch: {
    successMessage() {
      this.debouncedResetValues();
    },
    errorMessage() {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 3000);
  },
  mounted() {
    this.loadAssignmentFromRoute(this.$route.params.id);
    this.setModalListener();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== from.params.id) {
      this.loadAssignmentFromRoute(to.params.id);
    }
    next();
  },
  beforeDestroy() {
    // Timer'ları temizle
    this.stopInactivityTimer();
    this.clearCompletionTimer();

    // Network kontrolünü temizle
    this.stopNetworkCheck();

    // Geri tuşu listener'ını temizle
    if (this._contentModalPopstateHandler) {
      window.removeEventListener("popstate", this._contentModalPopstateHandler);
    }
    if (this._contentModalHistoryState && history.state && history.state.contentModal && history.state.id === this._contentModalHistoryState.id) {
      history.back();
    }
    this._contentModalHistoryState = null;

    const modal = UIkit.modal("#content_modal");
    const certificate_modal = UIkit.modal("#assignment_certificate_modal");
    if (modal) modal.$destroy(true);
    if (certificate_modal) certificate_modal.$destroy(true);
  },
};
</script>

<style src="./AssignmentDetails.css"/>
